import { render, staticRenderFns } from "./AssessmentView.vue?vue&type=template&id=1aa977ca&"
import script from "./AssessmentView.vue?vue&type=script&lang=ts&"
export * from "./AssessmentView.vue?vue&type=script&lang=ts&"
import style0 from "./AssessmentView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports